import { useMutation } from "react-query"
import { Hubstripe } from "../api/hubstripe"

export const useHubstripe = () => {

    const getCompanyFromCustomerId = useMutation((customerId: string) => Hubstripe.getCompanyFromCustomerId(customerId))
    const getDealsForCompanyId = useMutation((companyId: string) => Hubstripe.getDealsForCompanyId(companyId))
    const getSubscriptionsFromCustomerId = useMutation((customerId: string) => Hubstripe.getSubscriptionsFromCustomerId(customerId))
    const getInvoicesFromCustomerId = useMutation((customerId: string) => Hubstripe.getInvoicesFromCustomerId(customerId))
    const getCreditNotesFromCustomerId = useMutation((customerId: string) => Hubstripe.getCreditNotesFromCustomerId(customerId))
    const getCustomerFromCustomerId = useMutation((customerId: string) => Hubstripe.getCustomerFromCustomerId(customerId))
    const getPaymentMethodsFromCustomerId = useMutation((customerId: string) => Hubstripe.getPaymentMethodsFromCustomerId(customerId))
    const updatePaymentMethodForCustomerId = useMutation((data: { customerId: string, paymentMethodId: string }) => Hubstripe.updatePaymentMethodForCustomerId(data))
    const deletePaymentMethodForCustomerId = useMutation((data: { customerId: string, paymentMethodId: string }) => Hubstripe.deletePaymentMethodForCustomerId(data))

    return {
        getCompanyFromCustomerId,
        getDealsForCompanyId,
        getSubscriptionsFromCustomerId,
        getInvoicesFromCustomerId,
        getCreditNotesFromCustomerId,
        getCustomerFromCustomerId,
        getPaymentMethodsFromCustomerId,
        updatePaymentMethodForCustomerId,
        deletePaymentMethodForCustomerId
    }
}